// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../css-loader/index.js?minimize!../vue-loader/lib/style-rewriter.js?id=data-v-5b089780&scoped=true!./label.css");
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = require("!../vue-loader/node_modules/vue-style-loader/lib/addStylesClient.js")("0e725c5e", content, true);


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/~/vue-style-loader!./~/css-loader?minimize!./~/vue-loader/lib/style-rewriter.js?id=data-v-5b089780&scoped=true!./~/semantic-ui-label/label.css
// module id = 274
// module chunks = 0